import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.088.447a2 2 0 0 0-2.26 1.702l-.372 2.649 2.064-.315.29-2.056 8.91 1.253-1.252 8.912-2.695-.379.566 4.12 1.572.22a2 2 0 0 0 2.26-1.702l1.53-10.893A2 2 0 0 0 21 1.7L12.088.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.298 9.958A2 2 0 0 1 3 7.7l8.913-1.252a2 2 0 0 1 2.258 1.702l1.531 10.893A2 2 0 0 1 14 21.301l-8.912 1.253a2 2 0 0 1-2.26-1.703L1.299 9.958Zm4.24 1.424a1 1 0 1 1-1.981.278 1 1 0 0 1 1.98-.278Zm8.044 6.948-.835-5.941-3.314 4.707-1.922-1.548-2.84 4.035 3.341-.47 5.57-.783Z"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Images24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var Images24 = createIcon(IconComponent);